<template>
  <div class="restbooktimeset" :style="{gridTemplateColumns: '1200px 1fr'}">
    <div>
      <div class="switchs">
        <div>公休日(週)  <div v-if="Object.keys(info.WeekdayOff).filter(e => info.WeekdayOff[e]).length>0" :style="{marginLeft: '30px'}">{{Object.keys(info.WeekdayOff).filter(e => info.WeekdayOff[e]).map(e => '週'+wdy[e]).join('、')}}公休</div></div>
        <div>
          <div label="週一"><input type="checkbox" class="invert" :checked="info.WeekdayOff[1]"  @change="$emit('update', { 'WeekdayOff.1': $event.target.checked })"></div>
          <div label="週二"><input type="checkbox" class="invert" :checked="info.WeekdayOff[2]"  @change="$emit('update', { 'WeekdayOff.2': $event.target.checked })"></div>
          <div label="週三"><input type="checkbox" class="invert" :checked="info.WeekdayOff[3]"  @change="$emit('update', { 'WeekdayOff.3': $event.target.checked })"></div>
          <div label="週四"><input type="checkbox" class="invert" :checked="info.WeekdayOff[4]"  @change="$emit('update', { 'WeekdayOff.4': $event.target.checked })"></div>
          <div label="週五"><input type="checkbox" class="invert" :checked="info.WeekdayOff[5]"  @change="$emit('update', { 'WeekdayOff.5': $event.target.checked })"></div>
          <div label="週六"><input type="checkbox" class="invert" :checked="info.WeekdayOff[6]"  @change="$emit('update', { 'WeekdayOff.6': $event.target.checked })"></div>
          <div label="週日"><input type="checkbox" class="invert" :checked="info.WeekdayOff[0]"  @change="$emit('update', { 'WeekdayOff.0': $event.target.checked })"></div>
        </div>
      </div>
      <!-- <editCubeDate :title="(info.storeType==='restaurant' ? '用餐' : info.storeType==='event' ? '預約' : info.storeType==='tickets' ? '參觀' :'預購取貨')+'時段設定 - 平日'" :defaultValue="info.restTimeWeekday" @save="$emit('update', { restTimeWeekday: $event })"/>
      <editCubeDate :title="(info.storeType==='restaurant' ? '用餐' : info.storeType==='event' ? '預約' : info.storeType==='tickets' ? '參觀' :'預購取貨')+'時段設定 - 假日'" :defaultValue="info.restTimeHoliday" @save="$emit('update', { restTimeHoliday: $event })"/> -->

      <div>
        <div class="title" :style="{marginBottom: '40px'}">時段設定</div>
        <div class="wdyTime">
          <editCubeDate v-for="i in 7" :key="`wdy-${i}`" :style="{width: '135px'}"
          :title="'週'+wdy[i%7]" :col="true" :defaultValue="info.restTime[i%7]"
          @save="$emit('update', { [`restTime.${i%7}`]: $event })"/>
        </div>
      </div>
    </div>
    <div>
      <editCubeDate v-if="info.storeType==='restaurant' " title="國定假日時段設定" :defaultValue="info.restTimeHoliday" @save="$emit('update', { restTimeHoliday: $event }); "/>
      <editCubeDate v-if="info.storeType==='restaurant' " title="外帶時段設定" :defaultValue="info.restTimetakeout" @save="$emit('update', { restTimetakeout: $event }); "/>
      <editCubeDate :title="'加成時段設定 - 平日'"
       :defaultValue="info.restTimeWeekdayAdd" @save="$emit('update', { restTimeWeekdayAdd: $event })"/>
      <editCubeDate :title="'加成時段設定 - 假日'"
      :defaultValue="info.restTimeHolidayAdd" @save="$emit('update', { restTimeHolidayAdd: $event })"/>

    </div>
  </div>
</template>

<script>
import editCubeDate from '../../components/editCube3info.vue'
export default {
  name: 'restBookSummarySet',
  props: ['info'],
  components: {
    editCubeDate
  },
  data () {
    return {
      edit: false,
      restRatioHoliday: 0,
      restRatioWeekday: 0,
      editItem: null,
      wdy: ['日', '一', '二', '三', '四', '五', '六'],
      ServeReasons: []
    }
  },
  watch: {
  },
  computed: {
  }
}
</script>

<style lang="scss" scoped>
.wdyTime {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 20px;
}
.btns{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 28px;
  width: 100%;
  button {
    &:disabled {
      filter: contrast(.5);
    }
    border: none;
    width: 100px;
    height: 35px;
    border-radius: 20px;
    font-family: Noto Sans TC;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    &.confirm {
      background: #FF8B8B;
    }
    &.cancel {
      background: #B8B8B8;
    }
  }
}
.editBtn {
  margin-left: auto;
  width: 35px;
  height: 35px;
  background-color: var(--color-pri);
  background-image: url(./pen.svg);
  background-position: center;
  background-repeat: no-repeat;
  border: none;
  border-radius: 50%;
  background-size: 19px;
}
.attendance {
  height: 50px;
  display: block;
  font-weight: 400;
  font-size: 25px;
  letter-spacing: 0.1em;
  color: var(--color-pri);
  font-family: 'Roboto';
  &>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 80px;
  }
  &>div>div {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    &::after {
      content: '%';
    }
  }
  input {
    width: 100px;
    height: 40px;
    background: #FFFFFF;
    border: 1px solid #C4C4C4;
    border-radius: 3px;
    font-weight: 700;
    font-size: 20px;
    text-align: center;
    font-family: Roboto;
    letter-spacing: 2px;
    color: #FF8B8B;
      }
}
.rightInvItems {

  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;

  }
}
.title {
  font-family: "Noto Sans TC";
  font-style: normal;
  font-weight: 400;
  font-size: 25px;
  line-height: 29px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--color-pri);
  width: -webkit-fill-available;
}
.switchs {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 15px;
  margin-bottom: 15px;
  &>div:nth-child(2) {
    display: flex;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    width: 100%;
    height: 65px;
    align-items: center;
    justify-content: flex-start;
    margin-block: 10px 30px;
    &>div {
      width: 220px;
      height: 65px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-inline: 14px;
      border: 2px dashed var(--color-pri);
      border-radius: 5px;
      &::before {
        content: attr(label);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
      }
      &.min {
        width: 260px;
      }
      &.min::after{
        content: attr(after);
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 400;
        font-size: 20px;
        line-height: 23px;
        letter-spacing: 0.1em;
        color: var(--color-letter);
        align-self: x;
      }
    }
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    input[type=checkbox] {
      appearance: none;
      width: 39px;
      height: 20px;
      border-radius: 10px;
      position: relative;
        background-color: #FF8B8B;
      &:checked {
        background-color: #85CA9E;
      }
      &::before {
        content: '';
        display: inline-flex;
        width: 16px;
        height: 16px;
        position: absolute;
        left: 2px;
        right: auto;
        top: 2px;
        background-color: #FFFFFF;
        border-radius: 8px;
      }
      &:checked::before {
        right: 2px;
        left: auto;
      }
      &.invert {
        background-color: #85CA9E;
        &:checked {
          background-color: #FF8B8B;
        }
      }
    }
  }
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;

  }
}
.boxx {
  &>div:nth-child(1) {
    font-family: "Noto Sans TC";
    font-style: normal;
    font-weight: 400;
    font-size: 25px;
    line-height: 29px;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: var(--color-pri);
    width: -webkit-fill-available;
  }
}
.restbooktimeset {
  display: grid;
  &>div{
    &:nth-child(1) {
      padding: 25px 53px 25px 82px;
    }
    &:nth-child(2) {
      border-left: 1px solid var(--color-pri);
      padding: 25px 37px;
    }
    box-sizing: border-box;
    overflow-y: auto;
    height: calc(100vh - 90px);
  }
}

.desc {
  margin-top: 26px;
  color: var(--unnamed, #6D6D6D);
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 2px;
  gap: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
    input[type=text] {
      height: 40px;
      width: 100px;
      border: 1px solid #C4C4C4;
      text-align: center;
      font-size: 20px;
      font-weight: 700;
      font-family: Roboto;
      letter-spacing: 2px;
      color: #FF8B8B;
    }
    select {
      height: 40px;
      border: 1px solid #C4C4C4;
      border-radius: 3px;
      margin-right: 3px;
    }
  span {
    color: var(--unnamed, #FF8B8B);
    font-family: Noto Sans TC;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 30px */
    letter-spacing: 1px;
    margin-inline: .5em;
    &:nth-child(odd) {
      display: inline-flex;
      border: 1px solid #CACACA;
      width: 100px;
      height: 37px;
      align-items: center;
      justify-content: center;

    }
  }
}
</style>
